













































import { defineComponent } from '@nuxtjs/composition-api'
import CInfoModal from '~/components/shared/configurable/info/CInfoModal.vue'
import CImg from '~/components/shared/configurable/image/CImg.vue'
import { I18nLocale } from '~/models/shared/types'
import LocaleService from '~/services/LocaleService'
import { useDep } from '~/compositions/dependency-container'

export default defineComponent({
  components: {
    CInfoModal,
    CImg
  },
  props: {
    errors: {
      type: [Object],
      required: false,
      default() {
        return {
          el: null,
          en: null
        }
      }
    },
    selectedLanguage: {
      type: String,
      required: true
    },
    languages: {
      type: Array,
      required: true,
      default() {
        return ['el']
      }
    }
  },
  setup(_, { emit }) {
    const localeService = useDep(LocaleService)

    function getLanguageFlag(language: string) {
      switch (language) {
        case I18nLocale.EL: {
          return require(`~/assets/img/flags/4x3/el.svg`)
        }
        case I18nLocale.EN: {
          return require('~/assets/img/flags/4x3/en.svg')
        }
      }
    }

    function pickLanguage(language: string) {
      emit('change', language)
    }

    function getLanguageLabel(language: string) {
      return localeService.getLocaleLabel(language)
    }

    return {
      getLanguageFlag,
      pickLanguage,
      getLanguageLabel
    }
  }
})
